export default "__VITE_ASSET__CnfnxlOm__"